import { useTranslation } from 'react-i18next'

interface ImageSelectionStatusProps {
  selectedCount: number
  minImageCount: number | null
  maxImageCount: number | null
  isAllSelected?: boolean
}

export default function ImageSelectionStatus({
  selectedCount,
  maxImageCount,
  isAllSelected = false
}: ImageSelectionStatusProps) {
  const { t } = useTranslation()

  // Determine what text to show based on the constraints
  const getSelectionText = () => {
    if (isAllSelected) return t('common.allSelected')

    if (selectedCount === 0) return t('common.selectObjects')

    // When we have a maximum count, always show x / maxCount format
    if (maxImageCount !== null) {
      return t('common.selectedOfMax', { selected: selectedCount, max: maxImageCount })
    }

    // Default case (no max constraint)
    return t('common.selected', { count: selectedCount })
  }

  return (
    <div className='flex-1 flex justify-center items-center text-center font-semibold leading-5 text-primary'>
      {getSelectionText()}
    </div>
  )
}
